import { render, staticRenderFns } from "./CreateOfModal.vue?vue&type=template&id=dc482428&scoped=true&"
import script from "./CreateOfModal.vue?vue&type=script&lang=js&"
export * from "./CreateOfModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOfModal.vue?vue&type=style&index=0&id=dc482428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc482428",
  null
  
)

export default component.exports